import { render, staticRenderFns } from "./SortHeaderCell.vue?vue&type=template&id=ba3c6e20&"
import script from "./SortHeaderCell.vue?vue&type=script&lang=js&"
export * from "./SortHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./SortHeaderCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports